import fetchClient from '../utils/fetchClient';

/**
 * Получить версии кеша для текущего пользователя.
 * Лёгкий запрос — только 2 числа.
 */
export const getCacheVersions = async () => {
    return fetchClient.get('/cache/versions');
};
